import React from 'react';
import { FooterBase } from './styles';

function Footer() {
  return (
    <FooterBase>
      <p>
        {' '}
        <a href="https://www.hfsolutions.com.br/">
          HFSOLUTIONS
        </a>
      </p>
    </FooterBase>
  );
}

export default Footer;
